  

import axios from 'axios';

export const fetchActivitiesImage = async (setImageData, filename) => {
  try {
    console.log('................fetchActivitiesImageData....................') 
    console.log("filename",filename)
    if(filename){
      const response = await axios.get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getActivitiesImage/${filename}`, {
        responseType: 'blob' // Ensure response is treated as a Blob object
      });

      // Convert the Blob object to a base64 string
      const reader = new FileReader();
      reader.readAsDataURL(response.data);
      reader.onloadend = () => {
        const base64Image = reader.result;

        // Set the image data
        setImageData(base64Image);
      };
    }
  } catch (error) {
    console.error('Error fetching image data:', error);
  }
};
